import { render } from "./TrustedDeviceMixin.vue?vue&type=template&id=0c12eaea"
import script from "./TrustedDeviceMixin.vue?vue&type=script&lang=js"
export * from "./TrustedDeviceMixin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__